import React from 'react';

function PdfIcon({ ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            {...props}
        >
            <path
                d="M15 0C12.9375 0 11.25 1.6875 11.25 3.75V56.25C11.25 58.3125 12.9375 60 15 60H52.5C54.5625 60 56.25 58.3125 56.25 56.25V15L41.25 0H15Z"
                fill="#E2E5E7"
            />
            <path d="M45 15H56.25L41.25 0V11.25C41.25 13.3125 42.9375 15 45 15Z" fill="#B0B7BD" />
            <path d="M56.25 26.25L45 15H56.25V26.25Z" fill="#CAD1D8" />
            <path
                d="M48.75 48.75C48.75 49.7812 47.9062 50.625 46.875 50.625H5.625C4.59375 50.625 3.75 49.7812 3.75 48.75V30C3.75 28.9688 4.59375 28.125 5.625 28.125H46.875C47.9062 28.125 48.75 28.9688 48.75 30V48.75Z"
                fill="#F15642"
            />
            <path
                d="M11.9231 35.5256C11.9231 35.0306 12.3131 34.4906 12.9413 34.4906H16.4044C18.3544 34.4906 20.1094 35.7956 20.1094 38.2969C20.1094 40.6669 18.3544 41.9869 16.4044 41.9869H13.9013V43.9669C13.9013 44.6269 13.4813 45 12.9413 45C12.4463 45 11.9231 44.6269 11.9231 43.9669V35.5256ZM13.9013 36.3788V40.1138H16.4044C17.4094 40.1138 18.2044 39.2269 18.2044 38.2969C18.2044 37.2488 17.4094 36.3788 16.4044 36.3788H13.9013ZM23.0456 45C22.5506 45 22.0106 44.73 22.0106 44.0719V35.5556C22.0106 35.0175 22.5506 34.6256 23.0456 34.6256H26.4788C33.33 34.6256 33.18 45 26.6138 45H23.0456ZM23.9906 36.4556V43.1719H26.4788C30.5269 43.1719 30.7069 36.4556 26.4788 36.4556H23.9906ZM35.61 36.5756V38.9588H39.4331C39.9731 38.9588 40.5131 39.4988 40.5131 40.0219C40.5131 40.5169 39.9731 40.9219 39.4331 40.9219H35.61V44.07C35.61 44.595 35.2369 44.9981 34.7119 44.9981C34.0519 44.9981 33.6487 44.595 33.6487 44.07V35.5538C33.6487 35.0156 34.0538 34.6238 34.7119 34.6238H39.975C40.635 34.6238 41.025 35.0156 41.025 35.5538C41.025 36.0338 40.635 36.5738 39.975 36.5738H35.61V36.5756Z"
                fill="white"
            />
            <path
                d="M46.875 50.625H11.25V52.5H46.875C47.9062 52.5 48.75 51.6562 48.75 50.625V48.75C48.75 49.7812 47.9062 50.625 46.875 50.625Z"
                fill="#CAD1D8"
            />
        </svg>
    );
}

export default PdfIcon;
